import React from "react";
import PropTypes from "prop-types";

/* eslint-disable react/forbid-prop-types */

const ItemNormalLink = ({ item, className = "", onClick = () => {} }) => (
  <a href={item.relative} className={className} onClick={onClick}>
    {item.title}
  </a>
);

ItemNormalLink.propTypes = {
  item: PropTypes.any.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

ItemNormalLink.defaultProps = {
  className: "",
  onClick: () => {}
};

export default ItemNormalLink;
